<!--
 * @Author: Merlin
 * @Date: 2024-03-26 19:15:19
 * @LastEditors: Merlin
 * @LastEditTime: 2024-12-12 17:26:49
 * @Description: 此组件是左侧面板上的按钮：4 大操作按钮   
-->

<template>
    <div class="blackjack"
        v-if="!isInsure"
        mode="manual"
    >
        <!-- ↓ split ◆ -->
        <button
            v-click-and-rest
            :disabled="isDiabled || spiltedDisabled"
            :dismark="isDiabled || spiltedDisabled"
            @click="handleSplitAction"
        >
            <img src="../img/split.webp" />
            <span>{{ t.GameBlackJack.Split }}</span>
        </button>
        <!-- ↓ double ◆ ?hasBoughtInsurance --> 
        <button
            v-click-and-rest
            :disabled="isDiabled || isHited"
            :dismark="isDiabled || isHited"
            @click="handleDoubleAction"
        >
            <img src="../img/double.webp" />
            <span>
                {{ t.GameBlackJack.Double }}
            </span>
        </button>
        <!-- ↓ hit ◆ -->
        <button
            v-click-and-rest
            :disabled="isDiabled"
            :dismark="isDiabled"
            @click="handleHitAction"
        >
            <img src="../img/hit.png" />
            <span>{{ t.GameBlackJack.Hit }}</span>
        </button>
        <!-- ↓ stand ◆ -->
        <button
            v-click-and-rest
            :disabled="isDiabled"
            :dismark="isDiabled"
            @click="handleStandAction"
        >
            <img src="../img/stand.png" />
            <span>{{ t.GameBlackJack.Stand }}</span>
        </button>
    </div>
    <!-- ↑ 4大操作按钮 -->
    <!-- ↓ 购买 insurance 的按钮 -->
    <div v-else class="mb-3">
        <div class="flex flex-col space-y-2 items-center justify-center">
            <div class="inline-flex gap-2 text-white">
                <span>
                    {{ t.GameBlackJack.insuranceItem }}
                </span>
                <div>
                    <IconSvgUse
                        class="w-5 h-5 "
                        use="icon-question"
                    ></IconSvgUse>
                    <q-tooltip class="w-1/3 text-center"
                        anchor="top middle"
                        self="bottom middle"
                    >
                        {{ t.GameBlackJack.Insurance }}
                    </q-tooltip>
                </div>
            </div>
            <!-- ↑提示内容 -->
            <div class="flex w-full justify-center gap-2">
                <!-- ↓ 不买 -->
                <Button @click="buyInsure(false)" class="flex-1 !py-0 !px-0" mode="grayContained">
                    {{ t.No }}
                </Button>
                <!-- ↓ 买 -->
                <ButtonThe3DButton @click="buyInsure(true)" class="flex-1" color="blue">
                    {{ t.Accept }}
                </ButtonThe3DButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import useTranslation from '~/i18n/useTransLation';
import { 
    string2Number,
    Action,
    BetType,
    type CardInterface,
    type RoundDataInterface
} from '../ts/blackjackGame';


export default defineComponent({
    name: 'blackjackBetOptions',
    data() {
        const t = useTranslation();
        return {
            Action,
            isInsure: false, // 控制“天和”的图标可见性 
            t,
        };
    },
    props: {
        updateRound: {
            type: Function,
            required: true,
        },
        doRequest: {
            type: Function,
            required: true,
        },
        roundData: {
            type: Object as PropType<RoundDataInterface>,
            required: true,
        },
        handsUser1: {
            type: Array as PropType<CardInterface[]>,
            required: true,
        },
        handsUser2: {
            type: Array as PropType<CardInterface[]>,
            required: true,
        },
        handsUser1State: {
            type: String,
            required: true,
        },
        handsUser2State: {
            type: String,
            required: true,
        },
        isUpdatingRound: {
            type: Boolean,
            required: true,
        },
        roundStatus: {
            type: String,
            required: true,
        },
    },
    methods: { 
        // ↓ 操作： insurance
        async buyInsure(isConfirm=false) {
            const oParams = {
                type: Action.Insurance,
                isAccept: !!isConfirm,
            };
            if (!oParams.isAccept){
                (oParams as any).isBonusBet = true; // 不买保险时需要加此键
            }
            const oRes = await this.doRequest(oParams);
            if (!oRes) return;
            this.isInsure = false;
            const {insuranceAmount, dealerHand} = oRes;
            // console.log("买保险后庄家分数：", points); 
            if (insuranceAmount && dealerHand.points === 21){
                this.updateRound(oRes);
            }
        },
        // ↓ 操作： hit 
        async handleHitAction() {
            const oRes = await this.doRequest({
                type: Action.Hit,
            });
            if (!oRes) return;
            this.updateRound(oRes, Action.Hit);
        },
        // ↓ 操作： split 
        async handleSplitAction(){
            const oRes = await this.doRequest({
                type: Action.Split,
            });
            if (!oRes) return;
            this.updateRound(oRes, Action.Split);
        },
        // ↓ 操作： stand 
        async handleStandAction() {
            const oRes = await this.doRequest({
                type: Action.Stand,
            });
            if (!oRes) return;
            this.updateRound(oRes, Action.Stand);
            console.log("点击 stand\n", deepCopy(oRes));  
            // this.updateRound(this.standMockData(), Action.Stand);
        },
        // ↓ 操作： double （执行 double 与 stand 必然导致游戏结束） 
        async handleDoubleAction() { 
            const oRes = await this.doRequest({
                type: Action.Double,
            });
            if (!oRes) return;
            this.updateRound(oRes, Action.Double);
        },
    },
    computed: {
        // ↓ 计算是否禁用 split 按钮 
        spiltedDisabled() {
            if (this.handsUser2.length){ // 已经有了第2手的牌，禁用
                return true;
            }
            if (this.roundStatus === 'play') {
                if (this.handsUser1.length > 2) return true; // ← 禁用
                const [oCard01, oCard02] = this.handsUser1;
                if (!oCard01 || !oCard02) return true; // 禁用，以消除报错 
                const iCard01 = string2Number(oCard01.cardID);
                const iCard02 = string2Number(oCard02.cardID);
                // console.log("2张牌的分数：", iCard01, '-', iCard02);
                return iCard01 !== iCard02; // 2牌不同，禁用
            }
            if (this.handsUser1State === 'play' && this.handsUser1.length > 2) {
                return true;
            }
            // already splited
            // return this.handsUser2.length > 0;
        },
        // ↓ 
        isHited() {
            if (this.handsUser2.length === 0 && this.handsUser1.length > 2) {
                return true;
            }
            if (this.handsUser2State === 'split') {
                return this.handsUser2.length > 2;
            }
            if (this.handsUser1State === 'split') {
                return this.handsUser1.length > 2;
            }
        },
        // ↓ 设定4个操作按钮的禁用效果  
        isDiabled() {
            // ↓ 动画执行中 || 游戏状态未知 then 禁用
            if (this.isUpdatingRound || !this.roundStatus) {
                return true; 
            }
            const aDisableStatus = ['cashout', 'lose'];
            return aDisableStatus.includes(this.roundStatus);
        },
        // ↓ 是否买了，或明确放弃了保险 
        hasBoughtInsurance(){ 
            const bResult = this.roundData.insuranceAmount >= 0; 
            return bResult; 
        },
    },
    watch: {
        // ↓ 监听以及时显示买保险的按钮  
        roundData: {
            deep: true,
            immediate: true,
            handler() {
                const {dealerHand, firstHand, secondHand, insuranceAmount} = this.roundData;
                const aConditions = [
                    dealerHand?.cards?.[0]?.startsWith('A-'),
                    dealerHand?.cards?.length === 1,
                    firstHand?.type === 0,
                    !secondHand,
                    insuranceAmount >= 0 === false,
                ];
                this.isInsure = aConditions.every(Boolean);
            },
        },
    },
});
</script>

<style lang="scss" src="../style/blackjack-all.scss" scoped></style>



